import React from "react";
import close from '../../../images/icons/x.svg';
import profile from '../../../images/icons/no_image.png';
import {Col} from 'react-bootstrap';

export class BackendCard extends React.Component{

    handleRemove = () => {
        this.props.onRemove({id: this.props.jobID})
    };

    render() {
        return (
            <Col className="job-card-padding" sm={12} md={4} lg={4} xl={3}>
                <div key={this.props.id} className={"Vacantes__card"} >
                {this.props.triggered === true ?
                    (
                        <button className={"Vacantes__delete"} onClick={this.handleRemove} >
                            <img src={close} alt="" />
                        </button>
                    )
                    :
                    (
                        <button className={"Vacantes__delete--tiny"} >
                            <img src={close} alt="" />
                        </button>
                    )
                }
                <div className="Vacantes__card__cont">
                    <h5 className="Vacantes__card__name">{this.props.name}</h5>
                    <h3 className={"Vacantes__card__title"}>{this.props.jobTitle}</h3>
                    <h5 className="Vacantes__card__name">{this.props.locationName}</h5>
                </div>
                <div className={`Vacantes__card__${this.props.mode}`}
                    data-tip={this.props.status === "posted" ? "Publicado" : "Borrador o siendo editado"}
                >
                </div>
                <img
                    src={this.props.companyLogo ? this.props.companyLogo : profile}
                    className={"Vacantes__card__image"}
                    alt=""
                />
                {this.props.Permission === 'deny' ? 
                <div className="job-card-buttons Vacantes__card__btns">
                    <p className="button__rejected">Esta vacante fue rechazada</p> 
                </div> :
                <div className="job-card-buttons Vacantes__card__btns">
                    {this.props.Permission === 'waiting' ? 
                    <p className="button__waiting">En espera</p> :
                    <button
                        className="button__save"
                        type="button"
                        onClick={() => this.props.seeApplicants(this.props.jobID, this.props.vacancyOwner)}
                    >
                        Ver postulantes
                    </button>}
                    <button
                        className="button__submit"
                        type="button"
                        onClick={() => this.props.edit(this.props.jobID)}
                    >
                        Editar
                    </button>
                </div>}
            </div>
            </Col>    
        )
    }
}



export default BackendCard;
